import script from "./BackMusicPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackMusicPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./BackMusicPlayer.vue?vue&type=style&index=0&id=72129c3e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72129c3e"]])

export default __exports__